import { Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FieldConfig } from '@vendasta/platform-integrations';
import { CommonModule } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'platform-integration-urlfield',
  imports: [TranslateModule, CommonModule, MatIcon, MatButtonModule],
  templateUrl: './url.component.html',
  styleUrls: ['./url.component.scss'],
})
export class URLFieldComponent {
  field = input.required<FieldConfig>();
}
